<template>
     <back-layout title="Candidatos">
        <div class="container mx-auto pt-8 px-4 text-lg">
            <div class="flex lg:flex-row space-x-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-10">
                    <h3 class="font-bold border-b mb-4">Identidade</h3>
                    <p class="font-bold text-xl">{{ candidato.nome }}</p>
                    <p><span class="text-gray-400">Email:</span> <a :href="'mailto:' + candidato.email" class="underline">{{ candidato.email }}</a></p>
                    <p><span class="text-gray-400">Data nasc.:</span> {{ candidato.data_nasc }}</p>
                    <p>{{ candidato.doc_tipo }} - nº: {{ candidato.doc_num }}</p>
                    <p><span class="text-gray-400">Nif:</span> {{ candidato.nif_num }}</p>
                    <p class="mt-2">{{ candidato.morada }}<br>{{ candidato.cod_postal}} {{ candidato.localidade}}</p>
                    <p class="mt-2"><span class="text-gray-400">Tel:</span> <a :href="'tel:' + candidato.tel" class="underline">{{ candidato.tel }}</a></p>
                </div>
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-10">
                    
                    <h3 class="font-bold border-b mb-4">Trabalho</h3>
                    
                    <p><span class="text-gray-400">Tipo de Trabalho:</span> {{ candidato.tipo_trabalho}}</p>
                    <p><span class="text-gray-400">Horario pretendido:</span> <span v-if="!candidato.horario_alt">{{ candidato.horario }}</span><span v-else>{{ candidato.horario_alt}}</span></p>
                    <p><span class="text-gray-400">Transporte:</span> {{ candidato.transporte }}</p>
                    <p><span class="text-gray-400">Zona:</span> {{ candidato.zona }}</p>
                    <p><span class="text-gray-400">Disponibilidade Imediata:</span> <span v-if="!candidato.disponibilidade_alt">{{ candidato.disponibilidade }}</span><span v-else>{{ candidato.disponibilidade_alt}}</span></p>
                    <p><span class="text-gray-400">Habilitações:</span> {{ candidato.habilitacoes }}</p>
                    <p><span class="text-gray-400">Experiênica Profissional:</span> {{ candidato.exp_pro }}</p>
                 </div>
            </div>
            <jet-button @click.prevent="back()" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent border-0 active:border-0 focus:border-0 focus:ring-transparent active:shadow-0 focus:shadow-0 underline text-violet-500 px-0 mt-4"><icon name="back" />Voltar</jet-button>
            
        </div>
    </back-layout>
</template>


<script>
    import { defineComponent } from 'vue'
    import BackLayout from '@/Layouts/BackLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetButton from '@/Jetstream/Button.vue'
    import Icon from '@/Jetstream/Icon'
   

    export default defineComponent({
        components: {
            Head,
            Link,
            BackLayout,
            JetButton,
            Icon
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            candidato: Object
        },
        data() {
            return {
            }
        },
        methods: {
            back() {
                window.history.back()
            }
        },
    })
</script>